<template>
  <el-dialog
    class="auth-modal-dialog"
    :model-value="visible"
    width="min(900px, 94vw)"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    @close="handleClose"
    @closed="handleClosed"
  >
    <AuthShell @close="handleClose">
      <template #auth>
        <WeChatLoginPanel
          :agreements-accepted="agreementsAccepted"
          @agreements-change="handleAgreementChange"
          @login-success="handleLoginSuccess"
        />
      </template>
    </AuthShell>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { useUserStore } from '~/stores/user'

interface Props {
  visible: boolean
}

const props = defineProps<Props>()
const emit = defineEmits<{ (e: 'close'): void }>()

const userStore = useUserStore()
const { $event } = useNuxtApp()
const { t } = useI18n()

// 组件状态
const agreementsAccepted = ref(true)

// 监听弹窗显示状态，重置状态
watch(() => props.visible, (newValue) => {
  if (newValue) {
    // 弹窗打开时重置状态
    agreementsAccepted.value = true
  } else {
    // 弹窗关闭时触发事件清理
    $event.emit('auth-modal-closed')
  }
})

const handleClose = () => {
  emit('close')
}

const handleClosed = () => {
  // 弹窗完全关闭后的清理工作
  $event.emit('auth-modal-closed')
}

const handleAgreementChange = (value: boolean) => {
  agreementsAccepted.value = value
}

const handleLoginSuccess = () => {
  // 登录成功后关闭弹窗
  ElMessage.success(t('auth.messages.loginSuccess'))
  handleClose()
}
</script>

<style scoped lang="scss">
.auth-modal-dialog :deep(.el-dialog) {
  width: min(900px, 94vw) !important;
  max-width: 900px;
  margin: 3vh auto !important;
}

.auth-modal-dialog :deep(.el-dialog__body) {
  padding: 0;
  overflow: hidden;
}

@media (max-width: 767px) {
  .auth-modal-dialog :deep(.el-dialog) {
    width: 100vw !important;
    max-width: 100vw;
    margin: 0 !important;
    border-radius: 0;
    min-height: 100vh;
  }

  .auth-modal-dialog :deep(.el-dialog__body) {
    min-height: 100vh;
  }
}
</style>
